import React, { useState } from "react";
import clsx from "clsx";

import { LOGIN_ITEMS } from "../FaqCategoryItems/LoginItems";
import { LESSON_ITEMS } from "../FaqCategoryItems/LessonItems";
import { SETTING_ITEMS } from "../FaqCategoryItems/SettingItems";
import { STUDENT_DATA_ITEMS } from "../FaqCategoryItems/StudentDataItems";
import { GEAR_ITEMS } from "../FaqCategoryItems/GearItems";
import FaqAccordion from "../FaqAccordion";

import styles from "./FaqContent.module.scss";

const FAQ_CATEGORY_MAP = {
  login: {
    title: "ログイン(先生／生徒)",
    items: LOGIN_ITEMS,
  },
  lesson: {
    title: "授業・教材の利用",
    items: LESSON_ITEMS,
  },
  setting: {
    title: "登録/設定",
    items: SETTING_ITEMS,
  },
  studentData: {
    title: "生徒データのダウンロード",
    items: STUDENT_DATA_ITEMS,
  },
  gear: {
    title: "GEARの機能",
    items: GEAR_ITEMS,
  },
};

type FaqCategoryKey = keyof typeof FAQ_CATEGORY_MAP;

const FaqContent = () => {
  const [faqCategory, setFaqCategory] = useState<FaqCategoryKey>("login");

  return (
    <div className={styles.content}>
      <div
        className={styles.category}
        role="tablist"
        aria-label="よくあるご質問のカテゴリ"
      >
        {(Object.keys(FAQ_CATEGORY_MAP) as FaqCategoryKey[]).map(
          categoryKey => (
            <button
              className={clsx(
                styles.tab,
                categoryKey === faqCategory && styles.isActive,
              )}
              key={categoryKey}
              type="button"
              role="tab"
              aria-selected={categoryKey === faqCategory}
              onClick={() => setFaqCategory(categoryKey)}
            >
              {FAQ_CATEGORY_MAP[categoryKey].title}
            </button>
          ),
        )}
      </div>
      <div className={styles.list}>
        {FAQ_CATEGORY_MAP[faqCategory].items.map(item => (
          <div key={item.id}>
            <FaqAccordion faqData={item} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqContent;
